/* 🤖 this file was generated by svg-to-ts */
export const matIconMusicNote: {
  name: 'music-note';
  data: string;
} = {
  name: 'music-note',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m12 3 .01 10.55c-.59-.34-1.27-.55-2-.55a4.001 4.001 0 1 0 0 8c2.22 0 3.99-1.79 3.99-4V7h4V3h-6zm-1.99 16c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/></svg>`
};
